<template>
  <div class="card-body-item">
    <div v-if="useBlankIcon" :class="iconClass"></div>
    <div v-else>
      <svgicon :class="iconClass" :icon="`ks-icon-${icon}`" />
    </div>

    <div class="card-body-text">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      iconClass () {
        const classes = [`ks-icon-size-${this.iconSize}`]

        if (this.iconColor !== '') {
          classes.push(`ks-icon-color-${this.iconColor}`)
        }

        return classes.join(' ')
      },
      useBlankIcon () {
        return this.icon.toLowerCase() === 'blank'
      },
    },
    props: {
      icon: {
        type: String,
        default: 'alert',
      },
      iconColor: {
        type: String,
        default: '',
      },
      iconSize: {
        type: String,
        default: 'xs',
      },
    },
  }
</script>

<style lang="scss" scoped>
@use "~Styles/mixins";
@use "~Styles/variables";

  .card-body-item {
    display: flex;
    align-items: center;

    &:not(:last-child) {
      margin-bottom: variables.$card-body-item-spacing;
    }
  }

  .card-body-text {
    @include mixins.ellipsis();
    margin-left: 3px;
  }
</style>
